import ActionTypes from "../../constants/action_types";

export default function clearDefinitionGroups() {
  return {
    type: ActionTypes.ROLES_CLEAR.SUCCESS,
  };
}
